import { Modal, Button, Descriptions } from "antd"; // Import Modal and Button
import React, { useState } from "react"; // Import useState
import { HiOutlineInformationCircle } from "react-icons/hi";
import { RiEye2Line } from "react-icons/ri";
import { VscEye } from "react-icons/vsc";

function FinalModelViewJson({ rowItems }) {
  const [isModalOpen, setIsModalOpen] = useState(false); // Manage modal state

  // Modal handlers
  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);
  // const response = { Loss: 192.92825317382812, Accuracy: 0.09375 };
  const parsedData = rowItems?.celStatus?.final_model_qc?.resource
    ? JSON.parse(rowItems?.celStatus?.final_model_qc?.resource)
    : {};

  return (
    <div>
      {/* Trigger button */}
      {/* <RiEye2Line /> */}
      <VscEye
        title="Click for more info"
        color="#0057b8"
        size={16}
        onClick={showModal}
        style={{ cursor: "pointer" }}
      />
      {/* Modal */}
      <Modal
        title="Final Model"
        open={isModalOpen}
        onOk={handleOk}
        destroyOnClose={true}
        footer={null}
        onCancel={handleCancel}
      >
        <div className="py-1"></div>
        {/* <Descriptions layout="vertical" bordered>
          <Descriptions.Item label="Loss">
            {JSON.parse(rowItems?.celStatus?.final_model_qc?.resource)?.Loss}
          </Descriptions.Item>
          <Descriptions.Item label="Metrics">
            {
              JSON.parse(rowItems?.celStatus?.final_model_qc?.resource)
                ?.Accuracy
            }
          </Descriptions.Item>
        </Descriptions> */}
        <Descriptions layout="vertical" bordered>
          {Object.entries(parsedData).map(([key, value]) => (
            <Descriptions.Item label={key} key={key}>
              {value}
            </Descriptions.Item>
          ))}
        </Descriptions>
        {/* <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
          {JSON.stringify(
            rowItems?.celStatus?.final_model_qc?.resource,
            null,
            4
          )}
        </pre> */}
      </Modal>
    </div>
  );
}

export default FinalModelViewJson;
